import { Logger } from "../../logger/logger";

export interface INumberFormatOptions {
	value: number;
	locales: string | string[];
	intlOptions: Intl.NumberFormatOptions;
}

export class NumberHelper {
	public static defaultSixPrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 6, minimumFractionDigits: 6 };
	public static defaultFivePrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 5, minimumFractionDigits: 5 };
	public static defaultFourPrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 4, minimumFractionDigits: 4 };
	public static defaultThreePrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 3, minimumFractionDigits: 3 };
	public static defaultTwoPrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 2, minimumFractionDigits: 2 };
	public static defaultOnePrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 1, minimumFractionDigits: 1 };
	public static defaultZeroPrecisionDecimalFormatOptions: Intl.NumberFormatOptions = { style: "decimal", maximumFractionDigits: 0, minimumFractionDigits: 0 };
	public static germanLocale = "de-DE";
	public static precisionDecimalFormatOptions: Intl.NumberFormatOptions[] = [
		NumberHelper.defaultZeroPrecisionDecimalFormatOptions,
		NumberHelper.defaultOnePrecisionDecimalFormatOptions,
		NumberHelper.defaultTwoPrecisionDecimalFormatOptions,
		NumberHelper.defaultThreePrecisionDecimalFormatOptions,
		NumberHelper.defaultFourPrecisionDecimalFormatOptions,
		NumberHelper.defaultFivePrecisionDecimalFormatOptions,
		NumberHelper.defaultSixPrecisionDecimalFormatOptions
	]
	private static defaultNumberFormatValue: Intl.NumberFormat = null;
	public static toFormatString = (value: number | INumberFormatOptions, defaultValue: string = "") => {
		if (value == null) {
			return defaultValue;
		}
		let options: INumberFormatOptions;
		if (typeof value === "number") {
			options = {
				value,
				locales: NumberHelper.germanLocale,
				intlOptions: NumberHelper.defaultTwoPrecisionDecimalFormatOptions,
			};
		} else {
			options = value;
		}

		let formattedNumber: string;
		try {
			formattedNumber = new Intl.NumberFormat(options.locales, options.intlOptions).format(options.value);
		} catch (err) {
			Logger.warn(`Could not format number: ${value}`);
			formattedNumber = value.toString();
		}
		return formattedNumber;
	}

	public static toPercentageString = (main: number, reference: number, absolute: boolean = true) => {
		let result = "";
		if (main == null || reference == null) {
			return result;
		}

		try {
			let percentage = 100 / main * reference;
			if (absolute) {
				percentage = Math.abs(percentage);
			}

			let percentageString = NumberHelper.defaultNumberFormat().format(percentage);
			if (percentageString === "NaN") {
				throw new Error("percentage String is NaN");
			}
			result = percentageString;
		} catch (err) {
			Logger.warn(`Could not get percentage from values: ${main},${reference}`);
		}
		return result;
	}

	public static isNumberZeroOrGreater(input: number) {
		return input === 0 || input > 0;
	}

	private static readonly defaultNumberFormat = () => {
		if (!NumberHelper.defaultNumberFormatValue) {
			NumberHelper.defaultNumberFormatValue = new Intl.NumberFormat(NumberHelper.germanLocale, NumberHelper.defaultTwoPrecisionDecimalFormatOptions);
		}
		return NumberHelper.defaultNumberFormatValue;
	}
}